/* eslint semi:0 */
import { appDispatcher } from '../../application/AppDispatcher'
import { namespacedConsts } from '../../utils/object'

const CLASS_CONSTATNTS = namespacedConsts({
  GOOGLE_SEARCH: {
    ACTIONS: {
      READY: true,
      SEARCH_CLICKED: true,
    },
  },
})

export const TYPES = CLASS_CONSTATNTS.GOOGLE_SEARCH.ACTIONS

export const ready = () => {
  appDispatcher.dispatchAction.external({
    type: TYPES.READY,
  })
}

export const searchClicked = searchTerm => {
  appDispatcher.dispatchAction.view({
    type: TYPES.SEARCH_CLICKED,
    searchTerm,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/googleSearchActions.js